// extracted by mini-css-extract-plugin
module.exports = {"promocode__banner":"PromoCodeBanner_promocode__banner__u27Ac","threshold__disclaimer":"PromoCodeBanner_threshold__disclaimer__l_lbb"};